
const totalSqFtRanges = [
    { min: 0, max: 49999, value: '< 49,999' },
    { min: 50000, max: 99999, value: '50 - 99,999' },
    { min: 100000, max: 249999, value: '100 - 249,999' },
    { min: 250000, max: 499999, value: '250 - 499,999' },
    { min: 500000, max: 999999, value: '500,000 - 999,999' },
    { min: 1000000, max: 999999999, value: '1,000,000+' },
];

// TODO: don't need entire property object, just pass down values needed
export function matchName(property, keyword) {
    // If search criteria is empty, then this property should be included in the search results
    if (keyword === '' || !keyword) return true;

    return property.name.toLowerCase().indexOf(keyword.toLowerCase()) > -1;
}

// TODO: don't need entire property object, just pass down values needed
export function matchRegion(property, region) {
    if (region === '' || !region) return true;

    return property.region.toLowerCase() === region.toLowerCase();
}

// TODO: don't need entire property object, just pass down values needed
export function matchSubMarket(property, subMarket) {
    if (subMarket === '' || !subMarket || !property.submarket) return true;

    return property.submarket.toLowerCase() === subMarket.toLowerCase();
}

export function matchProjectType(property, type) {
    switch (type) {
        case 'in_service':
            return property.in_service;
        case 'development':
            return property.development;
        case 'redevelopment':
            return property.redevelopment;
        case 'repositioning':
            return property.repositioning;
        default:
            return true;
    }
}

export function matchTotalSqFt(rba, minSqFt) {
    if (minSqFt === '' || minSqFt === undefined) return true; // minSqFt could be 0

    const min = parseInt(minSqFt, 10);
    const max = totalSqFtRanges.find(range => range.min === min).max;

    return rba >= min && rba <= max;
}

// TODO: don't need entire property object, just pass down values needed
export function matchAvailableSqFt(property, filterOptions) {
    if (!filterOptions) return true;
    const { min, max } = filterOptions;
    
    if (min === '' || !min || max === '' || !max) return true;

    // Property without spaces
    if (!property.spaces) {
        // Match it with available sq ft
        return property.space_available >= min;
    }

    const availableSpaceMatch = property.spaces.some(space => matchSpaceAvailableInSpace(space, min, max));

    const minDivisibleMatch = property.spaces.some(space => matchMinDivisibleInSpace(space, min, max));

    const maxContiguousMatch = property.spaces.some(space => matchSpaceMaxContiguous(space, min, max));

    return minDivisibleMatch || availableSpaceMatch || maxContiguousMatch;
}

export function matchSpaceMaxContiguous(space, minSqFt, maxSqFt) {
    if (minSqFt === '' || !minSqFt || maxSqFt === '' || !maxSqFt) return true;

    const evaluatedSpace = parseInt(space.space.maximum_contiguous, 10);

    if ((evaluatedSpace >= 100000) && (maxSqFt === 100000 || minSqFt === 100000)) {
        return evaluatedSpace >= minSqFt;
    }

    return evaluatedSpace >= minSqFt && evaluatedSpace <= maxSqFt;
}

export function matchSpaceAvailableInSpace(space, minSqFt, maxSqFt) {
    if (minSqFt === '' || !minSqFt || maxSqFt === '' || !maxSqFt) return true;

    if (!parseInt(space.space.space_available, 10)) return false;


    if (parseInt(space.space.space_available, 10) >= 100000 && (maxSqFt === 100000 || minSqFt === 100000)) {
        return (
            parseInt(space.space.space_available, 10) >= minSqFt
        );
    }

    return (
        parseInt(space.space.space_available, 10) >= minSqFt &&
        parseInt(space.space.space_available, 10) <= maxSqFt
    );
}

export function matchMinDivisibleInSpace(space, minSqFt, maxSqFt) {
    if (minSqFt === '' || !minSqFt || maxSqFt === '' || !maxSqFt) return true;

    const evaluatedSpace = parseInt(space.space.minimum_divisible, 10);

    if ((evaluatedSpace >= 100000) && (maxSqFt === 100000 || minSqFt === 100000)) {
        return evaluatedSpace >= minSqFt;
    }

    return evaluatedSpace >= minSqFt && evaluatedSpace <= maxSqFt;
}

function sortSpaces(spaces, filters) {
    if (filters.availableSqFt === null) return spaces.map(item => ({ ...item, onTop: -1 }));

    const spacesOnTopMatch = spaces.map(item => {
        const spaceAvailableMatch = item.space.space_available >= filters.availableSqFt.value.min && item.space.space_available <= filters.availableSqFt.value.max;
        const maxContiguousMatch = item.space.maximum_contiguous >= filters.availableSqFt.value.min && item.space.maximum_contiguous <= filters.availableSqFt.value.max;
        const minDivisibleMatch = item.space.minimum_divisible >= filters.availableSqFt.value.min && item.space.minimum_divisible <= filters.availableSqFt.value.max;

        const spaceAvailableMaxSqFt = item.space.space_available >= 100000 && filters.availableSqFt.value.max >= 100000;
        const maxContiguousMaxSqFt = item.space.maximum_contiguous >= 100000 && filters.availableSqFt.value.max >= 100000;
        const minDivisibleMaxSqFt = item.space.minimum_divisible >= 100000 && filters.availableSqFt.value.max >= 100000;
       
        const onTop = (spaceAvailableMatch || maxContiguousMatch || minDivisibleMatch || spaceAvailableMaxSqFt || maxContiguousMaxSqFt || minDivisibleMaxSqFt) ? -1 : 1;

        return {
            ...item,
            onTop,
        };
    });

    const spacesSorted = spacesOnTopMatch.sort(item => item.onTop);

    return spacesSorted;
}

export function searchProperties(properties, keyword, filters) {
    if (!properties || keyword === undefined || !filters) return null;

    const results = properties.filter(property => {
        const keywordMatch = matchName(property, keyword);
        const regionMatch = (filters.region && filters.region !== 'all') ? matchRegion(property, filters.region.value) : true;
        const subMarketMatch = (filters.subMarket && filters.subMarket !== 'all') ? matchSubMarket(property, filters.subMarket.value) : true;
        const projectTypeMatch = filters.projectType ? matchProjectType(property, filters.projectType.value) : true;
        const totalSqFtMatch = filters.totalSqFt !== null ? matchTotalSqFt(property.rba, filters.totalSqFt.value) : true;
        const availableSqFtMatch = filters.availableSqFt ? matchAvailableSqFt(property, filters.availableSqFt.value) : true;

        return keywordMatch && regionMatch && subMarketMatch && projectTypeMatch && totalSqFtMatch && availableSqFtMatch;
    }).map(property => {
        const sortedSpaces = sortSpaces(property.spaces, filters);

        return {
            ...property,
            spaces: sortedSpaces,
            showMarker: true, // Show all hidden markers
        };
    });

    return results;
}
